import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function ThankyouPopup() {
    const { t } = useTranslation('clientPremium')
    return (
        // <div
        //     class="modal fade mt-5"
        //     id="thankyoupopup"
        //     tabindex="-1"
        //     role="dialog"
        //     aria-labelledby="myLargeModalLabel"
        //     aria-hidden="true"
        // >
            // <div class="modal-dialog modal-lg">
                <div class="thankyou-page-box">

                    <div class="thankyou-page-wrapper">
                        <div className='thankyou-page-container'>
                            <img src={'/integrationimages/thankyou.png'} />
                            {/* <p>You are now a member of our list of awesome peoples</p> */}
                            <Link className='mt-2' to={'/'}>{t('thankyou.backToHome')}</Link>
                        </div>
                    </div>
                </div>
            // </div>
        // </div>
    )
}
